import React, { memo, useCallback } from 'react';

import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { isNil } from 'lodash';
import PropTypes from 'prop-types';

import { getBadgeStyles, groupStyles, tabContentStyles } from './SecondaryTabGroupCDS.styles';

const defaultButtons = [];

const SecondaryTabGroupCDS = ({ buttons = defaultButtons, value, onChange, ...props }) => {
  const handleChange = useCallback(
    (_, newValue) => {
      if (!newValue) {
        return;
      }

      onChange(newValue);
    },
    [onChange],
  );

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      sx={groupStyles}
      value={value}
      onChange={handleChange}
      {...props}
    >
      {buttons.map(({ value: buttonValue, label, badge = null }) => {
        const isActive = value === buttonValue;

        return (
          <ToggleButton disableFocusRipple disableRipple key={buttonValue} value={buttonValue}>
            <Box sx={tabContentStyles}>
              <Typography variant={isActive ? 'medium14' : 'regular14'}>{label}</Typography>

              {!isNil(badge) && (
                <Box sx={getBadgeStyles({ isActive })}>
                  <Typography color="inherit" variant="medium12">
                    {badge}
                  </Typography>
                </Box>
              )}
            </Box>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

SecondaryTabGroupCDS.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
};

export default memo(SecondaryTabGroupCDS);
